import MultiSelect from './MultiSelect.component';
import MultiSelectTextMode from './displayMode/TextMode.component';

export { MultiSelectTextMode };
export default MultiSelect;
